import { AppAPI } from "../../api/AppApi.js";
import { AppDataService } from "../AppDataService.js";
import { ChunkDataService } from "../export.js";
import { objectAssignWithOverride } from "../utils.js";
import { HttpService } from "./HttpService.js";

export class AppHttpService extends AppDataService {
    constructor(req, conf, gudhub) {
      super(req, conf, gudhub);
  
      this.appApi = new AppAPI(req);

      let indexDBService = new HttpService(conf);


    //   this.chunkDataService = new ChunkDataService; //TODO move to 
    
      objectAssignWithOverride(this, indexDBService);
    }


    async getApp(id) {
        let sentData = await this.appApi.getApp(id);
        return this.processRequestedApp(id, sentData); //TODO check is it ok to trigger change isnide method for AppHttpService
    }

    //TODO should be getApp and getAppAndProcessData - refactor whole code to use them




    //TODO андрей говорил про то что там надо фильтровать айтемы удаленные, я так и не доделал



    async getAppWithoutProcessing(id) {
        return this.appApi.getApp(id);
    }

    async putApp(id, app) {
        // do nothing
    }
  
    static [Symbol.hasInstance](instance) {
        try {
            if (instance instanceof AppHttpService) return true;
            if (instance instanceof HttpService) return true; //TODO requires multiple inheritance, thhink how to overcome it
            return false;
        } catch (error) {
            return false;
        }
    }
};